module.exports = __webpack_public_path__ + "img/rutsche_aussen.f58b39ef.jpg";